<!-- Сплошная мишень раздела планирования из макета F18. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      fill="currentColor"
      d="M12 2A10 10 0 1 1 12 22A10 10 0 1 1 12 2ZM12 4.6A7.4 7.4 0 1 0 12 19.4A7.4 7.4 0 1 0 12 4.6Z"
    />
    <path
      fill-rule="evenodd"
      fill="currentColor"
      d="M12 7A5 5 0 1 1 12 17A5 5 0 1 1 12 7ZM12 9.6A2.4 2.4 0 1 0 12 14.4A2.4 2.4 0 1 0 12 9.6Z"
    />
  </svg>
</template>

<script>
export default {
  name: "PlanNavIcon",

  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    // AppIcon передаёт stroke всем иконкам; solid-иконка поглощает его без обводки SVG.
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
